import { AvatarSkeleton, TextSkeleton } from '@/components/Skeleton';

import { ZoraType } from '@/utils/zora';

const ChainAddressSkeleton = () => (
  <>
    <TextSkeleton width={150} height={18} className="hidden tablet:block ml-1 mt-0.5 mb-1" />
    <TextSkeleton width={100} height={14} className="tablet:hidden ml-1 mb-1" />
  </>
);

const ZoraPostTokenProfileHeaderLoader = () => (
  <div className="flex flex-col tablet:flex-row gap-4 tablet:gap-6 items-center p-6">
    <div className="flex-shrink-0 w-full tablet:w-auto">
      <div className="relative w-full h-auto tablet:size-45 max-h-75 tablet:max-h-45 aspect-square">
        <TextSkeleton
          width="100%"
          height="100%"
          className="size-full"
          lineClassName="rounded-lg!"
        />
        <AvatarSkeleton
          size={20}
          className="absolute -bottom-2 -right-2 border-2 border-token-gray-200"
          radius={8}
        />
      </div>
    </div>
    <div className="flex-1 min-w-0 w-full tablet:w-auto">
      <div className="flex justify-between items-start mb-4 gap-2">
        <div className="min-w-0 flex-1 flex flex-col gap-4 pb-2">
          <TextSkeleton width={250} height={34} className="ml-1" />
          <TextSkeleton width={150} height={20} className="ml-1" />
        </div>
      </div>
      <ChainAddressSkeleton />
    </div>
  </div>
);

interface TokenProfileHeaderLoaderProps {
  zoraType?: ZoraType;
}

export const TokenProfileHeaderLoader = ({ zoraType }: TokenProfileHeaderLoaderProps) => {
  if (zoraType === 'post') {
    return <ZoraPostTokenProfileHeaderLoader />;
  }

  const isZoraCreator = zoraType === 'creator';

  return (
    <div
      className="flex flex-col p-3 pb-2 pt-4 tablet:p-5 tablet:pb-4 tablet:pt-6 bg-transparent z-10 h-fit"
      style={{ gridArea: 'profileHeader' }}
    >
      <AvatarSkeleton size={40} className="hidden tablet:inline-block ml-1 mb-2.5" />

      <div className="grid grid-flow-col justify-start gap-1 items-center mb-1 pb-2 desktop:flex desktop:mb-1.5">
        <TextSkeleton width={250} height={34} className="hidden tablet:block ml-1" />
        <TextSkeleton width={160} height={28} className="tablet:hidden ml-1" />
        {!isZoraCreator && <TextSkeleton width={60} height={28} className="mr-2 desktop:ml-2" />}
      </div>

      {isZoraCreator && <TextSkeleton width={100} height={14} className="ml-1 mb-2 mt-2 pb-2" />}
      <ChainAddressSkeleton />
    </div>
  );
};
